"use client";
import React, { ReactElement, ReactNode, Ref, forwardRef, memo } from "react";
import {
  Box,
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
} from "@mui/material";
import { CheckBoxIcon, CheckBoxOutlineBlankIcon } from "@/icons";

const AppCheckbox = forwardRef(
  (
    { sx, formControlLabelProps, label = "", ...otherProps }: AppCheckboxProps,
    ref: Ref<HTMLInputElement>
  ) => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            sx={{
              backgroundColor: "common.white",
              width: 16,
              height: 16,
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "common.white",
              },

              "& .MuiTouchRipple-root": {
                backgroundColor: "green",
                zIndex: -1,
              },
              ...sx,
            }}
            inputRef={ref ? ref : null}
            icon={
              <CheckBoxOutlineBlankIcon
                sx={{
                  fontSize: "24px",
                  color: "text.secondary",
                }}
              />
            }
            checkedIcon={
              <CheckBoxIcon
                sx={{
                  fontSize: "26px",
                  color: "darkgreen.main",
                }}
              />
            }
            {...otherProps}
          />
        }
        label={label ? <Box className="ml-2">{label}</Box> : <>{label}</>}
        {...formControlLabelProps}
        sx={{
          gap: "0px",
          margin: 0,
          ...formControlLabelProps?.sx,
        }}
      />
    );
  }
);
AppCheckbox.displayName = "AppCheckbox";
export default memo(AppCheckbox);
export type AppCheckboxProps = CheckboxProps & {
  label?: string | ReactElement | ReactNode;
  formControlLabelProps?: Omit<FormControlLabelProps, "control" | "label">;
};
